var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVenueBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 800,
    viewBox: "0 0 1044 800",
    width: 1044,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#dcf908"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m968.362 273.719h88.0328v88.0328h-88.0328z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m968.362 361.751h88.0328v88.0328h-88.0328z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m968.362 97.5729h88.0328v88.0328h-88.0328z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m968.362 449.783h88.0328v88.0328h-88.0328z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m968.362 185.605h88.0328v88.0328h-88.0328z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m968.362 713.879h88.0328v88.0328h-88.0328z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m616.231 713.879h88.0328v88.0328h-88.0328z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m528.197 713.879h88.0328v88.0328h-88.0328z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m528.197 625.847h88.0328v88.0328h-88.0328z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440.165 537.815h88.0328v88.0328h-88.0328z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352.131 449.783h88.0328v88.0328h-88.0328z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.066 449.783h88.0328v88.0328h-88.0328z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440.165 625.847h88.0328v88.0328h-88.0328z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352.131 537.815h88.0328v88.0328h-88.0328z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.099 449.783h88.0328v88.0328h-88.0328z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.033 537.815h88.0328v88.0328h-88.0328z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.033 625.847h88.0328v88.0328h-88.0328z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 625.847h88.0328v88.0328h-88.0328z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 713.879h88.0328v88.0328h-88.0328z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m615.576 71.6478h88.0329v88.0329h-88.0329z",
    transform: "matrix(-1 0 0 -1 1231.152 143.2956)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m787.801 160.05h88.0329v88.0329h-88.0329z",
    transform: "matrix(-1 0 0 -1 1575.602 320.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m703.609 71.6478h88.0329v88.0329h-88.0329z",
    transform: "matrix(-1 0 0 -1 1407.218 143.2956)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m528.132 71.6478h88.0329v88.0329h-88.0329z",
    transform: "matrix(-1 0 0 -1 1056.264 143.2956)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenueBackground);
export default __webpack_public_path__ + "static/media/venue-background.54bfa22b6878e649d943e2a4b46e816d.svg";
export { ForwardRef as ReactComponent };